export enum PurchaseChannel {
    WEB = 'web',
    MOBILE = 'mobile'
}
